import axios from '@ts/utils/axios';

export const fetch = (params = {}, rest = {}) =>
    axios.get('/cart/get', { params, ...rest }).then(({ data }) => data);

export const extend = (params = {}, rest = {}) =>
    axios.get('/cart/extend', { params, ...rest }).then(({ data }) => data);

export const remove = (params = {}, rest = {}) =>
    axios.get('/cart/delete', { params, ...rest }).then(({ data }) => data);

export const removeItem = (params = {}, rest = {}) =>
    axios.get('/cart/delete-item', { params, ...rest }).then(({ data }) => data);

export const add = (payload = {}) => axios.post('/cart/add', payload).then(({ data }) => data);
